
import { toast } from "react-toastify"
import { fetchConToken } from "../helpers/fetch"

export const Users = {

    getOne: async (id) => {
        try {

            const resp = await fetchConToken(`usuarios/${id}`)
            const body = await resp.json()

            if (body.ok) {
                return body.data || null
            } else {
                toast.error('Lo sentimos, ocurrió un error')
                return null
            }

        } catch (error) {
            console.log('---error--', error)
            toast.error(error)
        }
    },

    save: async (data) => {
        try {

            const resp = await fetchConToken('usuarios', data, "POST")
            const body = await resp.json();

            if (body.ok) {
                toast.success('datos guardados')
                return body.data.id
            } else {
                toast.error('Lo sentimos, ocurrió un error')
                return 0
            }

        } catch (error) {
            console.log('---error--', error)
            toast.error(error)
        }
    },

    update: async (data) => {
        try {

            const resp = await fetchConToken(`usuarios/${data.id}`, data, "PUT")
            const body = await resp.json()

            if (body.ok) {
                toast.success('datos actualizados')
                return body.data
            } else {
                toast.error('Lo sentimos, ocurrió un error')
                return 0
            }

        } catch (error) {
            console.log(error)
            toast.error(error)
        }
    },

    updatePassword: async (data) => {
        try {

            const resp = await fetchConToken(`usuarios/update/password/${data.id}`, data, "PUT")
            const body = await resp.json()

            if (body.ok) {
                toast.success(body.msg)
                return body.data
            } else {
                toast.error(body.msg)

                if (body.error) {
                    return {
                        error: body.error
                    }
                }

                return false
            }

        } catch (error) {
            console.log(error)
            toast.error(error)
        }
    }

}